import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import elementClosest from 'element-closest';
import 'antd/dist/antd.css';
import './styles/index';
import * as serviceWorker from './serviceWorker';

elementClosest(window);

const appName = process.env.REACT_APP_NAME;
const imported = document.createElement('script');
imported.src = 'https://js.stripe.com/v3/';

if (appName === 'gs') {
	import('AppGS').then((module: any) => {
		document.head.appendChild(imported);
		module.default();
	});
}
if (appName === 'clients') {
	import('AppClient').then((module: any) => {
		document.head.appendChild(imported);
		module.default();
	});
}
if (appName === 'providers') {
	import('AppProviders').then((module: any) => {
		module.default();
	});
}
if (appName === 'signup') {
	import('AppSignup').then((module: any) => {
		document.head.appendChild(imported);
		module.default();
	});
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
